<template>
  <div>
    <NavBar v-if="sourceIsH5" :narBarTitle="title" />
    <div class="infoCard">
      <div v-html="details"></div>
    </div>
  </div>
</template>

<script>
import { queryBannersById } from '@/services/api'
import NavBar from '@/components/navBar'
import dayjs from 'dayjs'
import vueQr from 'vue-qr'
import Vue from 'vue'
import { Popup } from 'vant'
Vue.use(Popup)

export default {
  name: 'VisitorInfo',
  components: {
    NavBar,
    vueQr,
  },
  data() {
    return {
      user: {},
      sourceIsH5: true,
      title: '',
      info: {},
      details: '',
    }
  },
  methods: {
    async getInfo(id) {
      const regex = new RegExp('<img', 'gi')
      queryBannersById(id).then(res => {
        this.info = res
        this.title = res.title
        this.details = res.content.replace(regex, `<img style="max-width: 100%; height: auto"`)
      })
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getInfo(this.$route.query.id)
  },
}
</script>

<style lang="less" scoped>
.infoCard {
  padding: 10px;
  background-color: #fff;
}
</style>
